import React from 'react';

import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs/lib/defs/CHEVRON_RIGHT__12';
import {Scratchpad} from '../../scratchpad/Scratchpad';
import {clickedOnTravelerLogin} from '../../../utils/login.utils';
import GlobalizationSelector from '@homeaway/react-globalization-selector';
import URLSearchParams from 'url-search-params';

export class TrayMenu extends React.PureComponent {
    handleChangeGlobalSelector = (locale, siteUrl, currency) => {
        let countryCode = locale.split('_')[1].toLowerCase();
        let origin;
        let params;

        if (window && window.location) {
            if (countryCode === this.props.countryCode) {
                origin = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
                params = new URLSearchParams(window.location.search);
            } else {
                origin = siteUrl.replace(/\/$/, '');
                params = new URLSearchParams();
            }

            params.set('gx-locale', locale);
            params.set('gx-currency', currency);

            window.location.assign(`${origin}?${params.toString()}`);
        }
    };

    handleClickHeaderFlag = () => {
        this.props.setActiveMenu('flag');
    }

    handleClickHelp = () => {
        this.props.setActiveMenu('help');
    }

    handleClickLogin = (item) => {
        return (event) => {
            if (this.props.login.travelerLoginClickHandler && clickedOnTravelerLogin(event, item.cssClass)) {
                this.props.handleTravelerLogin();
                this.props.login.travelerLoginClickHandler();
            }
        };
    }

    // eslint-disable-next-line complexity
    render() {
        return (
            <div className="site-header-tray__menu">
                {!this.props.traveler && this.props.login && (
                    <div className="site-header-tray__menu-header">
                        <span className="site-header-tray__menu-header-greeting">{this.props.login.greeting}</span>
                        {this.props.flags && (
                            <span
                                aria-label={this.props.flags.items[0].text}
                                className="site-header-tray__menu-header-flag"
                                onClick={this.handleClickHeaderFlag}
                                onKeyPress={this.handleClickHeaderFlag}
                                role="button"
                                tabIndex={0}
                            >
                                <i aria-hidden="true" className={`flag-${this.props.flags.items[0].countryCode}`} />
                            </span>
                        )}
                    </div>
                )}
                {this.props.feedbackComponent}
                {this.props.traveler && (
                    <div className="site-header-tray__menu-header site-header-tray__menu-header--traveler">
                        <img
                            alt="avatar"
                            aria-hidden="true"
                            className="site-header-tray__menu-header-avatar img-circle"
                            role="presentation"
                            src={this.props.traveler.avatar.image}
                        />
                        <span className="site-header-tray__menu-header-greeting">{this.props.traveler.label}</span>
                        {this.props.flags && (
                            <span
                                aria-label={this.props.flags.items[0].text}
                                className="site-header-tray__menu-header-flag"
                                onClick={this.handleClickHeaderFlag}
                                onKeyPress={this.handleClickHeaderFlag}
                                role="button"
                                tabIndex={0}
                            >
                                <i aria-hidden="true" className={`flag-${this.props.flags.items[0].countryCode}`} />
                            </span>
                        )}
                    </div>
                )}
                <div className="site-header-tray__menu-items">
                    {this.props.scratchpad && (
                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={this.props.scratchpad.link}>
                            {this.props.traveler && (
                                <i aria-hidden className="site-header-tray__menu-item-icon icon-compose" />
                            )}
                            <Scratchpad
                                label={this.props.scratchpad.label}
                                link={this.props.scratchpad.link}
                            />
                        </a>
                    )}
                    {this.props.traveler && this.props.traveler.items.map((item, index) => {
                        if (item.cssClass === 'divider') {
                            return (
                                <div className="site-header-divider" key={`divider-${index}`} />
                            );
                        }

                        // FIXME: This is a hack to identify the inbox item
                        // TODO: Sort out a maintainable way to indentify and handle inbox and inbox data
                        if (item.cssClass === 'se-traveler-inbox') {
                            let unreadMessageCount = this.props.inbox.unreadMessageCount;

                            return (
                                <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={item.link || index}>
                                    <i className={`site-header-tray__menu-item-icon icon-${item.icon}`} />
                                    <span className="site-header-tray__menu-item-text">{item.text}</span>
                                    {(unreadMessageCount > 0) && (
                                        <div className="site-header-inbox__unread-badge site-header-inbox__unread-badge--animated badge bg-brand">
                                            <div className="site-header-inbox__unread-badge-count">{this.props.inbox.unreadMessageCount}</div>
                                        </div>
                                    )}
                                </a>
                            );
                        }

                        return (
                            <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={item.link || index}>
                                <i className={`site-header-tray__menu-item-icon icon-${item.icon}`} />
                                <span className="site-header-tray__menu-item-text">{item.text}</span>
                            </a>
                        );
                    })}
                    {this.props.login && this.props.login.items && this.props.login.items.map((item, index) =>
                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={item.link || index} onClick={this.handleClickLogin(item)}>{item.text}</a>
                    )}
                    {this.props.help && (
                        <a
                            className="site-header-tray__menu-item-link"
                            data-bypass="true"
                            onClick={this.handleClickHelp}
                            onKeyPress={this.handleClickHelp}
                            role="button"
                            tabIndex={0}
                        >{this.props.help.label} <SVGIcon inline markup={CHEVRON_RIGHT__12} /></a>
                    )}
                    {this.props.extraNav && this.props.extraNav.items && this.props.extraNav.items.map((item, index) =>
                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={index}>{item.text}</a>
                    )}
                    {this.props.lyp && (
                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={this.props.lyp.link}>{this.props.lyp.text}</a>
                    )}
                    {(this.props.renderCountryLanguageSelector || this.props.renderCurrencySelector) && (
                        <div className="site-header-tray__menu-item-globalization-selector">
                            <GlobalizationSelector
                                {...this.props.globalizationSelector}
                                countryCode={this.props.countryCode}
                                currencyCode={this.props.currencyCode}
                                languageCode={this.props.languageCode}
                                onGlobalSelectorChange={this.handleChangeGlobalSelector}
                                renderCountryLanguageSelector={this.props.renderCountryLanguageSelector}
                                renderCurrencySelector={this.props.renderCurrencySelector}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
